// extracted by mini-css-extract-plugin
export default {"container":"kk-z","disabled":"lk-z","subtotal":"mk-z","legal":"nk-z"};